























































































































































































































import { defineComponent, reactive, computed } from "@vue/composition-api";
import { getStore } from "../store";
import { useRouter } from "../router";
import { useI18n, getPrivacyPolicyLocalizedUrl } from '../i18n';
import { usePlatformChecker } from "../platform-checker";
import { useClientChecker } from "../client-checker";

const componentName = "Register";

export default defineComponent({
    name: componentName,

    setup(context) {
        const store = getStore(),
            { router, route } = useRouter(),
            platform = usePlatformChecker(),
            client = useClientChecker(),
            i18n = useI18n();

        const state = reactive({
            form: {
                givenName: "",
                lastName: "",
                email: "",
                language: route.value.query.language ?? "en",
                privacy: false,
            },
            registrationProgress: false,
            registrationSent: false,
            registrationErrorNotification: false,
            useExternalRegisterMethods: !client.clientIsToolbox.value,
            useExternalRegisterMethodGoogle: true,
            useExternalRegisterMethodFacebook: true,
            useExternalRegisterMethodApple: true,
        });

        const submitEnabled = computed(() => {
            return (
                !!state.form.email &&
                !!state.form.givenName &&
                !!state.form.lastName &&
                state.form.privacy
            );
        });

        const onCreateAccountClick = async () => {
            state.registrationProgress = true;

            const clientId = route.value.query.client_id;
            const returnUrl = route.value.query.returnUrl;
            let response = await store.dispatch("register", {
                ...state.form,
                clientId: clientId,
                returnUrl: returnUrl,
                platform: platform.getPlatform.value,
            });

            if (response && response.result == "OK") {
                state.registrationSent = true;
            } else {
                state.registrationErrorNotification = true;
            }

            state.registrationProgress = false;
        };

        const signinRoute = computed(() => {
            return { name: "access-signin", query: route.value.query };
        });

        const privacyPolicyRoute = computed(() => {
            return { name: "privacy-policy", query: route.value.query };
        });

        const privacyPolicyHref = computed(() => getPrivacyPolicyLocalizedUrl(i18n.locale));

        const onRegisterGoogle = () => {
            let qs =
                (window.location.search &&
                    `${window.location.search}&registration=1`) ||
                "?registration=1";
            window.location.assign(`/account/signin-external-google${qs}`);
        };

        const onRegisterFacebook = () => {
            let qs =
                (window.location.search &&
                    `${window.location.search}&registration=1`) ||
                "?registration=1";
            window.location.assign(`/account/signin-external-facebook${qs}`);
        };

        const onRegisterApple = () => {
            let qs =
                (window.location.search &&
                    `${window.location.search}&registration=1`) ||
                "?registration=1";
            window.location.assign(`/account/signin-external-apple${qs}`);
        };

        return {
            state,
            onCreateAccountClick,
            submitEnabled,
            signinRoute,
            privacyPolicyRoute,
            privacyPolicyHref,
            onRegisterGoogle,
            onRegisterFacebook,
            onRegisterApple,
        };
    },
});
